<template>
    <div>
        <form>
            <div class="password-rules">
                <div>
                    <small :class="this.passwordRules.totalLength ? 'ok' : ''">
                        New password must be at least 12 alphanumeric characters long <i class="material-icons">{{ this.passwordRules.totalLength ? 'check_circle' : 'not_interested' }}</i>
                    </small>
                </div>
                <div>
                    <small :class="this.passwordRules.charLength ? 'ok' : ''">
                        New password must have at least 1 character <i class="material-icons">{{ this.passwordRules.charLength ? 'check_circle' : 'not_interested' }}</i>
                    </small>
                </div>
                <div>
                    <small :class="this.passwordRules.capitalLength ? 'ok' : ''">
                        New password must have at least 1 capital letter <i class="material-icons">{{ this.passwordRules.capitalLength ? 'check_circle' : 'not_interested' }}</i>
                    </small>
                </div>
                <div>
                    <small :class="this.passwordRules.digitLength ? 'ok' : ''">
                        New password must have at least 1 digit <i class="material-icons">{{ this.passwordRules.digitLength ? 'check_circle' : 'not_interested' }}</i>
                    </small>
                </div>
            </div>

            <div class="errors" v-if="$validator.errors">
                <small v-for="(error, index) in $validator.errors.items" v-bind:key="index">
                    {{ error.msg }}
                </small>
            </div>

            <custom-input type="password" name="currentPassword" ref="currentPassword" :validationRules="{ required: true }" v-model="currentPassword" placeholder="Current password" autocomplete="off" v-if="!this.initialPasswordChange" />
            <custom-input type="password" name="password" ref="password" :validationRules="{ required: true }" v-model="password" placeholder="New password" id="password" autocomplete="off" />
            <custom-input type="password" name="confirm password" ref="confirmPassword" :validationRules="{ required: true, confirmed: 'password' }" v-model="passwordConfirm" placeholder="Confirm password" autocomplete="off" />
            <button v-if="onCancel" class="primary cancel" type="button" v-on:click="onCancel">Cancel</button>
            <button class="primary change" type="button" v-on:click="validation">Change</button>
        </form>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput';

export default {
    name: 'changePassword',
    mixins: [
        Default
    ],
    props: [
        'initialPasswordChange',
        'onComplete',
        'onCancel'
    ],
    inject: {
        $validator: '$validator' // Get the parent $validator instance
    },
    components: {
        customInput
    },
    data() {
        return {
            currentPassword: '',
            password: '',
            passwordConfirm: '',
            passwordRules: {
                totalLength: false,
                charLength: false,
                capitalLength: false,
                digitLength: false
            }
        };
    },
    watch: {
        password: function(newVal, oldVal) {
            this.passwordRules.totalLength = newVal.length >= 12;
            this.passwordRules.charLength = newVal.match(/[a-z]/g) ? newVal.match(/[a-z]/g).length >= 1 : false;
            this.passwordRules.capitalLength = newVal.match(/[A-Z]/g) ? newVal.match(/[A-Z]/g).length >= 1 : false;
            this.passwordRules.digitLength = newVal.match(/\d/g) ? newVal.match(/\d/g).length >= 1 : false;
        }
    },
    methods: {
        validation: function() {
            this.$validator.errors.clear();

            // Veevalidate validation
            let refs = [this.$refs.password, this.$refs.confirmPassword];
            if (!this.initialPasswordChange)
                refs.push(this.$refs.currentPassword);

            this.$parleyAdmin.validateMultiple(refs, function(value) {
                if (value)
                    this.customValidation();
                else
                    return false;
            }.bind(this));
        },
        customValidation: function() {
            // Custom validation
            if (Object.keys(this.passwordRules).some(key => !this.passwordRules[key]))
                this.$validator.errors.add({
                    msg: 'Please make sure your new password passes all the rules.'
                });
            else
                try {
                    this.changePassword();
                } catch (e) {
                    this.$validator.errors.add({ msg: 'Something went wrong, please log out and log in and try again.' });
                }
        },
        changePassword: function() {
            const url = this.initialPasswordChange ? 'v1.1/auth/password' : 'v1.1/users/password';
            const authorization = this.initialPasswordChange ? this.$store.getters[this.$store.types.token.getters.get_temp].token : this.$store.getters[this.$store.types.token.getters.get_nontemp].token;
            let data = {
                newPassword: this.password,
                confirmNewPassword: this.passwordConfirm,
                authorization: authorization
            };
            if (!this.initialPasswordChange)
                data.currentPassword = this.currentPassword;

            this.$http.put(url, data).then(response => {
                // Success callback
                // Clear input fields (reset data to initial values)
                Object.assign(this.$data, this.$options.data());

                if (this.onComplete) {
                    this.onComplete();
                    return;
                }

                if (this.initialPasswordChange) {
                    this.setup = !this.$store.getters[this.$store.types.user.getters.get].activated;

                    this.$router.push({name: 'tfaCheck', params: {callback: this.callback}}); // Redirect to 2Factor
                } else {
                    if (this.callback)
                        this.$router.push(this.callback); // Go to callback
                    else if (this.lastPath.fullPath)
                        this.$router.push(this.lastPath.fullPath); // Go to the lastPath we remembered
                    else
                        this.$router.push({name: 'accountsList'}); // Redirect to accounts list
                }
            }, response => {
                // Error callback
                this.$validator.errors.clear();

                let notifications = JSON.parse(response.bodyText).notifications;
                if (notifications.filter((element) => { return element.message === 'newPassword_should_not_be_the_same_as_the_current_one'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'New password should not be the same as the current one'
                    });
                if (notifications.filter((element) => { return element.message === 'password_should_be_at_least_12_long'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'New password must be at least 12 alphanumeric characters long'
                    });
                if (notifications.filter((element) => { return element.message === 'password_required_at_least_8_characters'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'New password must contain at least 8 characters'
                    });
                if (notifications.filter((element) => { return element.message === 'password_requires_at_least_1_capital'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'New password must contain at least 1 uppercase character'
                    });
                if (notifications.filter((element) => { return element.message === 'password_requires_at_least_2_digits'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'New password must contain at least 2 digits'
                    });
                if (notifications.filter((element) => { return element.message === 'given_password_does_not_match_with_current_one'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'Password does not match your current password'
                    });
                if (notifications.filter((element) => { return element.message === 'user_already_changed_password'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'You have already changed your password, please log in with your new password'
                    });
                if (notifications.filter((element) => { return element.message === 'new_password_should_be_different_than_current_password'; }).length > 0)
                    this.$validator.errors.add({
                        msg: 'New password cannot be the same as your current password'
                    });

                // This is shown for any other error that didn't match the ones above
                if (!this.$validator.errors.any())
                    this.$validator.errors.add({
                        msg: 'Something went wrong while updating your password, please try again later'
                    });
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    form {
        width: 28em;

        .errors {
            small {
                color: red;
            }
        }

        .password-rules {
            color: #F4808E;
            /*width: 28em;*/
            padding-bottom: 1em;

            div {
                small {
                    &.ok {
                        color: $primary-color;
                    }

                    i {
                        float: left;
                        margin-right: .5em;
                    }
                }
            }
        }

        button {
            float: left;
            height: 3em;
            width: 7em;
            line-height: unset;
            margin: 0;

            &.cancel {
                background-color: $secondary-color;
                float: left;
            }

            &.change {
                float: right;
            }
        }
    }
</style>
